(function () {    
    angular.module('bizPartEngage').directive('bizMyTasks', bizMyTasksDirective);    

    bizMyTasksDirective.$inject = ["bizCore"];    

    function bizMyTasksDirective(bizCoreProvider) {
        var directive = {
            restrict: 'E',
            scope: {
                activity: '=?',
                includeCompleted: '@?',
                showFilter: '@?',
                ignoreTaskId: '@?'
            },
            templateUrl: bizCoreProvider.getView('bizMyTasksDirective', 'FrontEnd/Modules/EngagementGoals/Views/Directives/myTasks.html'),
            controller: bizMyTasksController,
            controllerAs: 'vm',
            bindToController: true
        };

        bizMyTasksController.$inject = ["$scope", "modules.goals.service", "$state"];

        return directive;

        function bizMyTasksController($scope, engagementGoalsService, $state) {
            var vm = this;
            vm.OrderBy = ['Status', 'Deadline'];
            vm.OrderDesc = false;

            vm.ChangeOrderBy = ChangeOrderBy;
            vm.SetCurrentFilterMode = SetCurrentFilterMode;

            function ChangeOrderBy(order, desc) {
                switch(order) {
                    case 'Task':
                        if(vm.OrderBy == 'Text' && desc === undefined) {
                            vm.OrderDesc = !vm.OrderDesc;
                        }
                        else {
                            vm.OrderBy = 'Text';
                            vm.OrderDesc = desc || false;
                        }
                    break;
                    case 'Activity':
                        if(vm.OrderBy == 'LinkedObject.Text' && desc === undefined) {
                            vm.OrderDesc = !vm.OrderDesc;
                        }
                        else {
                            vm.OrderBy = 'LinkedObject.Text';
                            vm.OrderDesc = desc || false;
                        }
                    break;
                    case 'Goal':
                        if(vm.OrderBy == 'LinkedObject.GoalName' && desc === undefined) {
                            vm.OrderDesc = !vm.OrderDesc;
                        }
                        else {
                            vm.OrderBy = 'LinkedObject.GoalName';
                            vm.OrderDesc = desc || false;
                        }
                    break; 
                    case 'Deadline':
                        if(vm.OrderBy == 'DateLocal' && desc === undefined) {
                            vm.OrderDesc = !vm.OrderDesc;
                        }
                        else {
                            vm.OrderBy = 'DateLocal';
                            vm.OrderDesc = desc || false;
                        }
                    break; 
                    case 'Status':
                        if(vm.OrderBy[0] == 'Status' && vm.OrderBy[1] == 'Deadline' && desc === undefined) {
                            vm.OrderDesc = !vm.OrderDesc;
                        }
                        else {
                            vm.OrderBy = ['Status', 'Deadline'];
                            vm.OrderDesc = desc || false;
                        }
                    break; 
                }
            }

            vm.FilterMode = {
                All: {                    
                    Match: function (task) {                        
                        return ~~vm.ignoreTaskId !== task.Id;
                    }
                },
                Upcoming: {                    
                    Match: function (task) {
                        return ~~vm.ignoreTaskId !== task.Id && !IsExpired(task) && !task.IsCompleted;
                    }
                },
                Expired: {                    
                    Match: function (task) {
                        return ~~vm.ignoreTaskId !== task.Id && IsExpired(task);
                    }
                },
                Completed: {                    
                    Match: function (task) {
                        return ~~vm.ignoreTaskId !== task.Id && task.IsCompleted;
                    }
                }
            };

            function SetCurrentFilterMode(mode) {
                vm.CurrentFilterMode = vm.FilterMode[mode];
                setLocalStorage('myTaskFilterMode', mode);
            }

            vm.CurrentFilterMode = vm.FilterMode.All;

            vm.GetTasks = GetTasks;
            vm.CompleteToDo = CompleteToDo;
            vm.Init = Init;
            vm.GotoTask = GotoTask;
            vm.IsExpired = IsExpired;            
            vm.FilterTasks = FilterTasks;
            vm.GetTaskCount = GetTaskCount;
            vm.AddTaskStatus = AddTaskStatus;

            function FilterTasks() {
                return function (tsk) {
                    return vm.CurrentFilterMode.Match(tsk);                    
                }
            }

            function GetTaskCount(filterMode) {
                var count = 0;
                if (!vm.tasks) {
                    return count;
                }
                for (var i = 0; i < vm.tasks.length; i++) {
                    if (filterMode.Match(vm.tasks[i])) {
                        count++;
                    }
                }
                return count;
            }

            function GotoTask(task) {
                $state.go("base.modules.goals.tasks", { id: task.Id });
            }

            function GetTasks() {
                var inclCompleted = vm.includeCompleted === 'true';
                engagementGoalsService.GetTasks(inclCompleted).then(GetTasksCallback);

                function GetTasksCallback(response) {
                    if (!vm.tasks) {
                        var tasks = BizPartCoreHelpers.getResponseValue(response, []);
                        vm.tasks = tasks;

                        vm.AddTaskStatus(vm.tasks);

                        console.log(vm.tasks);
                    }
                }
            }

            function AddTaskStatus(tasks) {
                // 30 = Completed, 20 = Upcomming, 10 = Too late

                for(var i = 0; i < tasks.length; i++) {
                    if(tasks[i].IsCompleted) {
                        tasks[i].Status = 30;
                    }
                    else if(vm.IsExpired(tasks[i])) {
                        tasks[i].Status = 10;
                    }
                    else if(!vm.IsExpired(tasks[i]) && !tasks[i].IsCompleted) {
                        tasks[i].Status = 20;
                    }
                }
            }

            function CompleteToDo(todo) {
                if (!todo.IsCompleted) {
                    engagementGoalsService.CompleteTask(todo).then(CompleteToDoCallback);
                }

                function CompleteToDoCallback(response) {
                    var index = vm.tasks.indexOf(todo);
                    if (vm.includeCompleted === 'true') {
                        todo.IsCompleted = true;
                        todo.Status = 30;
                    } else {
                        vm.tasks.splice(index, 1);
                    }
                }
            }

            function IsExpired(task) {
                return !task.IsCompleted && moment(task.DateLocal) < BizPartCoreHelpers.getDateNow();
            }            

            function Init() {
                var currentFilterMode = getLocalStorage('myTaskFilterMode');
                if(currentFilterMode) {
                    vm.CurrentFilterMode = vm.FilterMode[currentFilterMode];
                }

                if (vm.activity && vm.activity.ToDoList) {
                    vm.tasks = vm.activity.ToDoList;
                    vm.AddTaskStatus(vm.tasks);
                } else {
                    vm.GetTasks();
                }
            }

            vm.$onInit = vm.Init;

            $scope.$watch("vm.activity", function () {
                if (vm.activity && vm.activity.ToDoList) {
                    vm.tasks = vm.activity.ToDoList;
                }
            });
        }
    }

}());